import { Typography } from "antd";

import { BlockContainer } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContainer/BlockContainer";
import { BlockContent } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContent/BlockContent";
import { BlockTitle } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockTitle/BlockTitle";
import {
    getJourneyNodeIcon,
    getJourneyNodeTypeConfig,
} from "Components/elements/RVFlow/Shared/JourneyNodePresentation";
import { NodeType } from "Types/Journey";

import { GenesysFormItemKeys } from "../../../../Components/JourneyActionsPanel/NodeEditorPanel/Components/_DemoFormItems/constants";
import { useJourneyBlockData } from "../../Shared/Hooks/useJourneyBlockData/useJourneyBlockData";

import type { SharedBlockProps } from "Components/elements/RVFlow/RVFlowTypes";

import styles from "./GenesysBlock.module.scss";

const BLOCK_TITLE = "Integrations";
const NODE_TITLE = "Create Genesys Call";
const NODE_PROMPT = "Select Call";

const BLOCK_VARIANT = getJourneyNodeTypeConfig(NodeType.DEMO_Genesys).variant;
const BLOCK_ICON = getJourneyNodeIcon(NodeType.DEMO_Genesys);

export function GenesysBlock({ data, variant }: SharedBlockProps): JSX.Element {
    const { [GenesysFormItemKeys.genesysName]: campaignName, [GenesysFormItemKeys.genesysID]: campaignId } = data || {};
    const isNodeConfigured = !!campaignName && !!campaignId;

    const preferedNodeName = `${campaignName} (ID#${campaignId})`;

    const { fallBackTitle, isActive, nodeName } = useJourneyBlockData({
        variant,
        isNodeConfigured,
        preferedNodeName,
        blockTitle: BLOCK_TITLE,
        nodeTitle: NODE_TITLE,
        nodePropmpt: NODE_PROMPT,
    });

    return (
        <BlockContainer iconClassName={styles.GenesysBrand} variant={BLOCK_VARIANT} icon={BLOCK_ICON}>
            <BlockTitle nodeData={data} fallBackDisplay={fallBackTitle}></BlockTitle>

            <BlockContent isActive={isActive}>
                <Typography.Text>{nodeName}</Typography.Text>
            </BlockContent>
        </BlockContainer>
    );
}
